// @ts-strict-ignore
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromCompany from '../reducers/company.reducer';
import { getContactList, getContactLoading } from './contact.selectors';
import { selectRouteParams } from './router.selectors';

export const getCompanyState =
  createFeatureSelector<fromCompany.State>('company');
export const getCompanyList = createSelector(
  getCompanyState,
  fromCompany.selectAll,
);

export const getCompanyEntities = createSelector(
  getCompanyState,
  fromCompany.selectEntities,
);

export const getCompanySearch = createSelector(
  getCompanyState,
  fromCompany.getCompanySearch,
);
export const getCompanySort = createSelector(
  getCompanyState,
  fromCompany.getCompanySort,
);
export const getCompanySortList = createSelector(
  getCompanyState,
  fromCompany.getSortByList,
);
export const getCompanyLoading = createSelector(
  getCompanyState,
  fromCompany.getCompanyLoading,
);
export const getCompanyError = createSelector(
  getCompanyState,
  fromCompany.getCompanyError,
);

export const getCompanyWithContacts = createSelector(
  getCompanyList,
  getContactList,
  getCompanySearch,
  getCompanySort,
  (companies, contacts, search, sortBy) => {
    return companies
      ?.map((company) => {
        return {
          ...company,
          employees: contacts.filter(
            (contact) => contact.company === company.id,
          ),
        };
      })
      .filter((company) =>
        company.name.toLowerCase().includes(search.toLowerCase()),
      )
      .sort((a, b) => {
        if (!sortBy) return 0;
        if (sortBy.value === 'numbers')
          return sortBy.order
            ? a.employees.length < b.employees.length
              ? 1
              : -1
            : a.employees.length > b.employees.length
              ? 1
              : -1;

        return sortBy.order
          ? b.name.localeCompare(a.name)
          : a.name.localeCompare(b.name);
      });
  },
);

export const getActiveCompany = createSelector(
  getCompanyEntities,
  getContactList,
  selectRouteParams,
  (entities, contacts, params) => {
    if (!entities[params.id]) return;
    return {
      ...entities[params.id],
      employees:
        contacts.length === 0
          ? []
          : contacts.filter(
              (contact) => contact.company === entities[params.id].id,
            ),
    };
  },
);

export const getCompanyById = (id: number) => {
  return createSelector(
    getCompanyEntities,
    getContactList,
    (entities, contacts) => {
      if (!entities[id]) return;
      return {
        ...entities[id],
        employees:
          contacts.length === 0
            ? []
            : contacts.filter((contact) => contact.company === entities[id].id),
      };
    },
  );
};

export const getItemsLoading = createSelector(
  getCompanyLoading,
  getContactLoading,
  (companyLoading, contactLoading) => {
    return companyLoading || contactLoading;
  },
);
